/* eslint-disable no-undef */
import React, {Component} from 'react';
import { withGoogleMap, GoogleMap, Marker, InfoWindow} from "react-google-maps";
import {Link} from 'react-router-dom'
const {  LatLngBounds }  = google.maps;
import './Map.css'


const BranchStatusMap = withGoogleMap(props => (
    <GoogleMap options={{maxZoom: 16, minZoom: 2, disableDefaultUI: true, zoomControl: true}} defaultZoom={4} maxZoom={4} ref={(map)=>{
        if(map !== null) {
            if(props.bounds !== null) {
                map.fitBounds(props.bounds)
            }
        }
    }}>
        {props.markers.map((marker, index) => (
            <Marker
                key={index}
                position={marker.position}
                onClick={() => props.onMarkerClick(marker)}>
                {marker.showInfo && (
                    <InfoWindow onCloseClick={() => props.onMarkerClose(marker)}>
                        <div>{marker.infoContent}</div>
                    </InfoWindow>
                )}
            </Marker>
        ))}
    </GoogleMap>
));

export default class Map extends Component {
    constructor(props) {
        super(props);

        let config = this.createMapConfig();

        this.state = {
            ...config
        };
    }

    createMapConfig() {
        let bounds = new LatLngBounds();
        let markers = [];


        this.props.branches.forEach((b,i) => {
            let latLng = {
                lat: b.geoLatitude,
                lng: b.geoLongitude,
            };

            bounds.extend(latLng);

            markers.push({
                    branch: b,
                    position: latLng,
                    key: b.branchId,
                    defaultAnimation: 2,
                    showInfo: false,
                    infoContent: (
                        <div>
                            <div>{b.branchName}</div>
                            <div>
                                <Link style={{color: 'blue'}} to={`/customers/${b.customerId}/${b.branchId}`}>Go to branch</Link>
                            </div>
                        </div>
                    )
                }
            )
        });

        return {
            markers: markers,
            bounds: bounds
        }
    };


    handleMarkerClick = this.handleMarkerClick.bind(this);
    handleMarkerClose = this.handleMarkerClose.bind(this);

    handleMarkerClick(targetMarker) {
        this.setState({
            bounds: null,
            markers: this.state.markers.map(marker => {
                return {
                    ...marker,
                    showInfo: marker === targetMarker,
                };
            }),
        });
    }

    handleMarkerClose(targetMarker) {
        this.setState({
            markers: this.state.markers.map(marker => {
                if (marker === targetMarker) {
                    return {
                        ...marker,
                        showInfo: false,
                    };
                }
                return marker;
            }),
        });
    }

    render() {
        return (
                <BranchStatusMap
                    containerElement={
                        <div style={{ height: 'calc(100% - 60px)' }} />
                    }
                    mapElement={
                        <div style={{ height: '100%' }} />
                    }
                    center={this.state.center}
                    markers={this.state.markers}
                    bounds={this.state.bounds}
                    onMarkerClick={this.handleMarkerClick}
                    onMarkerClose={this.handleMarkerClose}
                />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/map/Map.js